/* eslint no-param-reassign: "off" */
const INVALID_URL_RESULT = {
  isValid: false,
  message: 'Please enter a valid URL and it must start with http:// or https://',
};

export function urlValidator(url) {
  if (typeof url !== 'string' || !/^https?:\/\//.test(url)) {
    return INVALID_URL_RESULT;
  }
  try {
    const urlObj = new URL(url);
    if (!['http:', 'https:'].includes(urlObj.protocol)) {
      return INVALID_URL_RESULT;
    }
    return {
      isValid: true,
      message: '',
    };
  } catch (err) {
    return INVALID_URL_RESULT;
  }
}

const validators = {
  urlValidator,
};

export default {
  install(app) {
    app.config.globalProperties.$validator = validators;
  },
};
